import React, { Component } from "react";
import "./SideBar.css"
import SidebarRow from "./SidebarRow"
import GroupIcon from '@material-ui/icons/Group';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';

class SideBar extends Component {
    state = {
        page: this.props.page
    };

    set_page = (page) => {
        this.setState({page: page});
    }

    render() {
        return (
            <div className="side_bar">
                <SidebarRow baseDir={this.props.baseDir} page={this.state.page} Icon={SettingsEthernetIcon} title="Networks" name="Networks"/>
                <SidebarRow baseDir={this.props.baseDir} page={this.state.page} Icon={GroupIcon} title="My Organization" name="Organization"/>
                {this.props.isStaff ? 
                    <SidebarRow baseDir={this.props.baseDir} page={this.state.page} Icon={GroupIcon} title="Beta Access" name="Access"/> 
                    : <></>}
            </div>
        )}
}
export default SideBar;